// extracted by mini-css-extract-plugin
export default {"backgroundHeader":"G429de3"};